export default __webpack_public_path__ + "media/images/icons/monitoring-filled-ec7fb4fec28bd2bcc08cf08590f8ed4f.svg";